module.exports = __webpack_public_path__ + "img/slide3.5d0ebe36.png";